export default `
<section class="third bg-white container center pt-4">
<h2 class="h2 mb-2">
    ++{{section4Header1}}
</h2>
<h6 class="p mb-3">
    ++{{section4Text1}}
</h6>	
	
</section>
`